import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

export const getContactAPI = (search:any,page:any,limit:any,sort_by:any,sort_direction:any) => {
  return Http.get(`contact?search=${search}&page=${page}&limit=${limit}&sort_by=${sort_by}&sort_direction=${sort_direction}`);
};
export const getContactDetailsAPI = (id:any) => {
  return Http.get(`contact/${id}`);
};
export const deleteContactAPI = (id: any) => {
  return Http.delete(`contact/${id}`);
};